/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Market_SignalsInputs */

const en_directory_launch_market_signals = /** @type {(inputs: Directory_Launch_Market_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market Signals`)
};

const zh_directory_launch_market_signals = /** @type {(inputs: Directory_Launch_Market_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场信号`)
};

/**
* | output |
* | --- |
* | "Market Signals" |
*
* @param {Directory_Launch_Market_SignalsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_market_signals = /** @type {((inputs?: Directory_Launch_Market_SignalsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Market_SignalsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_market_signals(inputs)
	return zh_directory_launch_market_signals(inputs)
});
export { directory_launch_market_signals as "directory.launch.market_signals" }